function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9364 7.36359C15.2879 7.71506 15.2879 8.28491 14.9364 8.63638L8.63644 14.9364C8.28497 15.2879 7.71512 15.2879 7.36365 14.9364L1.06365 8.63638C0.887889 8.46062 0.800021 8.23024 0.800049 7.99988V3.49999C0.800049 2.00882 2.00888 0.799988 3.50005 0.799988H8.00029C8.23054 0.80005 8.46077 0.887918 8.63644 1.06359L14.9364 7.36359ZM3.50005 4.39999C3.9971 4.39999 4.40005 3.99704 4.40005 3.49999C4.40005 3.00293 3.9971 2.59999 3.50005 2.59999C3.00299 2.59999 2.60005 3.00293 2.60005 3.49999C2.60005 3.99704 3.00299 4.39999 3.50005 4.39999Z",
  fill: "currentColor"
});
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.91ab6fdd.svg";
export { ForwardRef as ReactComponent };